<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Clientes
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Nuevo cliente</h2>
    <a routerLink="/clients" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <form [formGroup]="clientForm" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label for="rut" class="block text-sm font-bold mb-2">Ingresa el RUT<span class="text-danger-500">*</span>:</label>
        <input id="rut" type="text" formControlName="rut" class="input" placeholder="11111111-1">
        <div *ngIf="rut.invalid && (rut.dirty || rut.touched)" class="text-danger-500 text-sm">
          El RUT es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="razonSocial" class="block text-sm font-bold mb-2">Ingresa la razón social<span class="text-danger-500">*</span>:</label>
        <input id="razonSocial" type="text" formControlName="razonSocial" class="input" placeholder="Razón Social">
        <div *ngIf="razonSocial.invalid && (razonSocial.dirty || razonSocial.touched)" class="text-danger-500 text-sm">
          La razón social es obligatoria.
        </div>
      </div>
      <div class="mb-4">
        <label for="giro" class="block text-sm font-bold mb-2">Ingresa el giro<span class="text-danger-500">*</span>:</label>
        <input id="giro" type="text" formControlName="giro" class="input" placeholder="Giro">
        <div *ngIf="giro.invalid && (giro.dirty || giro.touched)" class="text-danger-500 text-sm">
          El giro es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="direccionLegal" class="block text-sm font-bold mb-2">Ingresa la dirección legal<span class="text-danger-500">*</span>:</label>
        <input id="direccionLegal" type="text" formControlName="direccionLegal" class="input" placeholder="Dirección Legal">
        <div *ngIf="direccionLegal.invalid && (direccionLegal.dirty || direccionLegal.touched)" class="text-danger-500 text-sm">
          La dirección legal es obligatoria.
        </div>
      </div>
      <div class="mb-4">
        <label for="direccionDespacho" class="block text-sm font-bold mb-2">Ingresa la dirección de despacho<span class="text-danger-500">*</span>:</label>
        <input id="direccionDespacho" type="text" formControlName="direccionDespacho" class="input" placeholder="Dirección de Despacho">
        <div *ngIf="direccionDespacho.invalid && (direccionDespacho.dirty || direccionDespacho.touched)" class="text-danger-500 text-sm">
          La dirección de despacho es obligatoria.
        </div>
      </div>
      <div *ngIf="errorMessage" class="mb-4 text-danger-500">
        {{ errorMessage }}
      </div>
      <div class="flex justify-end">
        <button type="submit" class="button button-success">
          Crear Cliente
        </button>
      </div>
    </form>
  </div>
</div>
